(() => {
  if (document.documentElement.hasAttribute('data-a6-vector-arrows')) return;
  document.documentElement.setAttribute('data-a6-vector-arrows', '');
  const scope = '.px-nav, .px-nav-mobile, .a6-shipping-announcement, main, .site-footer, .px-cart-dialog, .pdp-dialog, .quiz-dialog';
  const skip = 'script, style, template, noscript, textarea, select, svg, [contenteditable="true"]';
  const arrowPattern = /\u2197[\uFE0E\uFE0F]?/g;
  const namespace = 'http://www.w3.org/2000/svg';
  const makeArrow = () => {
    const svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('class', 'a6-ne-arrow');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.65');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS(namespace, 'path');
    path.setAttribute('d', 'M5 19 19 5M5 5h14v14');
    svg.append(path);
    return svg;
  };
  const replaceArrow = (node) => {
    if (!node.nodeValue?.includes('\u2197')) return;
    const parent = node.parentElement;
    if (!parent || !parent.closest(scope) || parent.closest(skip)) return;
    const control = parent.closest('a, button, summary');
    if (!control) return;
    const readableLabel = control.textContent.replace(arrowPattern, '').trim();
    if (!readableLabel && !control.getAttribute('aria-label') && !control.getAttribute('aria-labelledby')) return;
    const parts = node.nodeValue.split(arrowPattern);
    const fragment = document.createDocumentFragment();
    parts.forEach((part, index) => {
      if (part) fragment.append(document.createTextNode(part));
      if (index < parts.length - 1) fragment.append(makeArrow());
    });
    node.replaceWith(fragment);
  };
  const normalize = (root) => {
    if (root.nodeType === Node.TEXT_NODE) return replaceArrow(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(skip)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const candidates = [];
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes('\u2197')) candidates.push(node);
    }
    candidates.forEach(replaceArrow);
  };
  const start = () => {
    if (!document.body.matches('.a6-theme, .a6-v725-preview')) return;
    normalize(document.body);
    let scheduled = false;
    const pending = new Set();
    const flush = () => {
      scheduled = false;
      const roots = Array.from(pending).filter((node) => node.isConnected);
      pending.clear();
      roots.filter((node) => !roots.some((other) => other !== node && other.contains(node))).forEach(normalize);
    };
    new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'characterData') {
          if (record.target.nodeValue.includes('\u2197')) pending.add(record.target);
        } else {
          record.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE || (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes('\u2197'))) pending.add(node);
          });
        }
      });
      if (!scheduled && pending.size) {
        scheduled = true;
        queueMicrotask(flush);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
